import React, { useCallback } from 'react';

import useStepsProgress from 'pages/Checkout/hooks/useStepsProgress.hook';

import useDeliverTo from '../../hooks/useDeliverTo.hook';
import useDeliverToStatus from '../../hooks/useDeliverToStatus.hook';
import useDelivery from '../../hooks/useDelivery.hook';
import useScreen from '../../hooks/useScreen.hook';

import DeliveryLayout from '../DeliveryLayout';
import DynamicLoader from 'routes/DynamicLoader';
import { isNonEmptyObject } from 'utils/helpers.util';

const DeliverToDrawer = DynamicLoader(() =>
  import(/* webpackChunkName: "DeliverToDrawer" */ '../DeliverToDrawer')
) as any;
const DeliverToLocationCx: React.FC = () => {
  const {
    isDeliveryInformationAvailable,
    currentlySelectedAddress,
    defaultAddress,
    addressChangeSuccessHandler,
  } = useDelivery();

  // Steps setter
  const [{ deliverTo }, { setStepDeliverToStatus }] = useStepsProgress();

  // Delivery main hook
  const [deliverToState] = useDeliverTo(defaultAddress[0], currentlySelectedAddress);
  useDeliverToStatus(deliverTo, deliverToState, setStepDeliverToStatus);

  const { error } = deliverToState;
  const [{ isCartList }] = useScreen();
  const processHandler = useCallback(() => {
    addressChangeSuccessHandler(currentlySelectedAddress);
  }, [currentlySelectedAddress, addressChangeSuccessHandler]);
  return (
    <>
      <DeliveryLayout
        error={error}
        addressDetails={
          isNonEmptyObject(currentlySelectedAddress) ? currentlySelectedAddress : defaultAddress[0]
        }
        loading={!isDeliveryInformationAvailable}
      />

      {/* 
        this is only for drawer 
      */}

      {isCartList && (
        <DeliverToDrawer deliverToState={deliverToState} onProceedHandler={processHandler} />
      )}
    </>
  );
};
export default DeliverToLocationCx;
